import React from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import './index.css'
import { initGA4 } from './utils/analytics'
import App from './App'

// Bootstrap GA4 before the app renders so page-view tracking works
// even when the production index.html lacks the gtag snippet.
initGA4()

const container = document.getElementById('root')
const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
)

// Use hydrate when prerendered HTML exists (react-snap)
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app)
} else {
  ReactDOM.createRoot(container).render(app)
}
